export default __webpack_public_path__ + "static/gangbanger-eca2353b38c4130996b069e387c60e70.svg";